import { cn } from "@/src/lib/utils";
import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Heading, Text } from "@/src/components/ui/Typography";
import { Button } from "@/src/components/ui/Button";

interface NotFoundMessageProps {
  eyebrow?: string;
  title: string;
  description: string;
  ctaLabel: string;
  /** Omit for a plain button that only runs `onCtaClick`. */
  ctaHref?: string;
  /** Runs on CTA click in addition to navigating — e.g. to clear a search. */
  onCtaClick?: () => void;
  /** "h1" for a standalone not-found page; "h2" when embedded below a page
   *  that already has its own h1 (e.g. an author's empty post list). */
  headingLevel?: "h1" | "h2";
  className?: string;
}

export function NotFoundMessage({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaHref,
  onCtaClick,
  headingLevel = "h1",
  className,
}: NotFoundMessageProps) {
  return (
    <Section className={cn("bg-white", className)}>
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          {eyebrow && (
            <Text size="labelSM" className="uppercase tracking-widest text-brand">
              {eyebrow}
            </Text>
          )}
          <Heading as={headingLevel} size="displayLG" className={eyebrow ? "mt-3" : undefined}>
            {title}
          </Heading>
          <Text size="bodyLG" className="mt-4 text-neutral-600">
            {description}
          </Text>
          <Button href={ctaHref} onClick={onCtaClick} className="mt-8">
            {ctaLabel}
          </Button>
        </div>
      </Container>
    </Section>
  );
}
